// classes.ts
export default {
  container:
    'flex flex-col h-full text-gray-300  transition-all ease-linear duration-300',
  toggleButton: 'absolute -right-2 top-4 z-51',
  content:
    'py-8 transition-all overflow-hidden! overflow-y-auto!  ease-in-out duration-300 w-[78px]',
};
